import { z } from 'zod';

import { emailSchema, newPasswordSchema } from './auth.js';

export const registrationStatusSchema = z.object({
  enabled: z.boolean(),
});
export type RegistrationStatusDto = z.infer<typeof registrationStatusSchema>;

export const registerRequestSchema = z.object({
  workspaceName: z.string().trim().min(1, 'Введите название рабочего пространства').max(200),
  email: emailSchema,
  password: newPasswordSchema,
  firstName: z.string().trim().min(1, 'Введите имя').max(120).optional(),
  lastName: z.string().trim().max(120).optional(),
});
export type RegisterRequest = z.infer<typeof registerRequestSchema>;

export const platformRegistrationSchema = z.object({
  enabled: z.boolean(),
});
export type PlatformRegistrationDto = z.infer<typeof platformRegistrationSchema>;

export const platformRegistrationPatchSchema = z.object({
  enabled: z.boolean(),
});
export type PlatformRegistrationPatchDto = z.infer<typeof platformRegistrationPatchSchema>;

export const platformWorkspaceSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  slug: z.string(),
  createdAt: z.string(),
  selfRegistered: z.boolean(),
  adminEmail: z.string().email().nullable(),
  adminName: z.string().nullable(),
  userCount: z.number().int().nonnegative(),
});
export type PlatformWorkspaceDto = z.infer<typeof platformWorkspaceSchema>;

export const platformWorkspacesResponseSchema = z.object({
  workspaces: z.array(platformWorkspaceSchema),
});
export type PlatformWorkspacesResponseDto = z.infer<typeof platformWorkspacesResponseSchema>;
